<div class="modal">
  <div class="modal__header">
    <div class="grid-row grid-row--aic">
      <div class="grid-col">
        <div class="h3">Other User Payment Method Will Be Lost</div>
      </div>
      <div class="grid-col grid-col--auto">
        <button (click)="cancelChange()" type="button" class="modal__close">
          <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none"
               stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
    </div>
  </div>
  <div class="modal__cont">
    <p>This payment method was created by a different user that is associated with the same account. After choosing to
      change this payment method, you will be unable to change back to this one.</p>
    <br>
    <p>Click "Cancel" to stop this process, or choose "Continue" to change the payment method. If you think this is an
      error please contact <span class="mt--100 text-link"><a href="{{getEmail()}}">support&#64;aiwyn.ai</a></span> for
      assistance.</p>
    <div class="mt--125 grid-row grid-row--jcb">
      <div class="grid-col grid-col--auto">
        <button
          andButton
          (click)="cancelChange()"
          type="button"
        >
          Cancel
        </button>
      </div>
      <div class="grid-col grid-col--auto">
        <button
          andButton
          color="primary"
          (click)="changePaymentMethod()"
          type="button"
        >
          Continue
        </button>
      </div>
    </div>
  </div>
</div>
